import { useRef } from 'react'
import { DisplayExamDate, DotSizeStatusLabel } from '../../common'
import { openDetailPanel } from '../../../actions/app'
import {
  updateSelectedApprovalRequest,
  stopProcessingApprovalRequest,
} from '../../../actions/approvalRequests'
import {
  selectSelectedApprovalRequestId,
  selectSelectedEducationPeriod,
} from '../../../selectors/approvalRequests'
import {
  AR_ID,
  AR_AICODE,
  AR_STATUS,
  AR_EXAMDATE,
} from '../../../constants/ApprovalRequestConstants'
import tableUtilStyles from '../../../assets/style/scss/table-utils.scss'

const mapStateToProps = (state, ownProps) => {
  const { approvalRequest, idField, approvalRequestColumns, grouped } = ownProps

  return {
    approvalRequest,
    selectedApprovalRequest: selectSelectedApprovalRequestId(state),
    idField,
    approvalRequestColumns,
    grouped,
    educationPeriodCd: selectSelectedEducationPeriod(state),
  }
}

const ApprovalRequestRow = connect(mapStateToProps, {
  openDetailPanel,
  updateSelectedApprovalRequest,
  stopProcessingApprovalRequest,
})(
  ({
    approvalRequest,
    selectedApprovalRequest,
    idField,
    approvalRequestColumns,
    grouped,
    itemSize,
    index,
    educationPeriodCd,
    updateSelectedApprovalRequest,
    stopProcessingApprovalRequest,
    openDetailPanel,
  }) => {
    const approvalRequestRowRef = useRef(null)
    const isSelectedRow = approvalRequest[idField] === selectedApprovalRequest

    // Return an Org Row for grouped data
    if (approvalRequest.orgRow) {
      return (
        <tr>
          <th
            scope="colgroup"
            id={approvalRequest.aiCode}
            colSpan="4"
            style={{
              paddingTop: '24px',
              paddingBottom: '0',
              backgroundColor: '#f0f0f0',
            }}
          >
            <span style={{ fontWeight: 'bold' }}>AI: {approvalRequest.aiCode}</span>
            {!approvalRequest.contiguousUSInd && (
              <span
                className="cb-glyph cb-location"
                style={{ fontWeight: 'normal', marginLeft: '10px', color: '#0077C8' }}
              />
            )}
          </th>
        </tr>
      )
    }

    // Return a normal row
    return (
      <tr
        key={approvalRequest[idField]}
        className={`${index % 2 ? `${tableUtilStyles.even} ` : `${tableUtilStyles.odd} `}${
          isSelectedRow ? tableUtilStyles['selected-row'] : ''
        }`}
        aria-label={`${isSelectedRow ? 'selected ' : ''}approval request - ${
          approvalRequest[idField]
        }`}
      >
        {approvalRequestColumns.map(col => {
          switch (col.header) {
            case AR_ID:
              return (
                <th
                  key={col.header}
                  scope="row"
                  headers={`approvalRequestIdCol${grouped ? ` ${approvalRequest.aiCode}` : ''}`}
                  style={itemSize ? { height: itemSize } : {}}
                >
                  <button
                    type="button"
                    id={`approvalRequest_${approvalRequest[idField]}`}
                    className="btn-link"
                    ref={approvalRequestRowRef}
                    aria-expanded={isSelectedRow}
                    onClick={() => {
                      stopProcessingApprovalRequest()
                      updateSelectedApprovalRequest(approvalRequest[idField])
                      openDetailPanel('ApprovalRequestDetailPanel', {
                        closeFocusElem: approvalRequestRowRef.current,
                      })
                    }}
                  >
                    {approvalRequest[idField]}
                  </button>
                </th>
              )

            case AR_AICODE:
              return !grouped ? (
                <td key={col.header} headers="aiCodeCol">
                  {approvalRequest.aiCode}
                </td>
              ) : null

            case AR_STATUS:
              return (
                <td
                  key={col.header}
                  headers={`statusCol${grouped ? ` ${approvalRequest.aiCode}` : ''}`}
                >
                  <DotSizeStatusLabel status={approvalRequest.etsApprovalStatus} />
                </td>
              )

            case AR_EXAMDATE:
              return (
                <td
                  key={col.header}
                  headers={`examDateCol${grouped ? ` ${approvalRequest.aiCode}` : ''}`}
                >
                  <DisplayExamDate data={approvalRequest} educationPeriodCd={educationPeriodCd} />
                </td>
              )

            default:
              return (
                <td
                  key={col.header}
                  headers={`${col.header}${grouped ? ` ${approvalRequest.aiCode}` : ''}`}
                >
                  {approvalRequest[col.field]}
                </td>
              )
          }
        })}
      </tr>
    )
  }
)

export default ApprovalRequestRow
